/** @jsx jsx */
import * as React from 'react';
import { jsx } from '@emotion/core';
import Highlighter from 'react-highlight-words';
import AddBlock from '@clearkit/icons/glyphs/AddBlock';

import { CKCheckbox } from '../CKCheckbox';
import { CKSelectListItem } from '../CKSelectListItem';

export interface CKMultiPickerItemProps {
  inputValue: string;
  isCreating: boolean;
  isDisabled: boolean;
  isHighlighted: boolean;
  isSelected: boolean;
  itemMetaRenderer: React.ReactNode;
  itemProps: any;
  label: string;
  icon?: React.ReactNode;
  textToHighlight: string;
  value: string;
}

const CKMultiPickerItem = (props: CKMultiPickerItemProps) => {
  const {
    inputValue,
    isCreating,
    isDisabled,
    isHighlighted,
    isSelected,
    itemMetaRenderer,
    itemProps,
    label,
    icon,
    textToHighlight,
    value,
  } = props;

  return (
    <CKSelectListItem
      isHighlighted={isHighlighted}
      isSelected={isSelected}
      isDisabled={isDisabled}
      isMultiSelect
      itemMetaRenderer={itemMetaRenderer}
      {...itemProps}
      accessoryRenderer={
        isCreating ? (
          <AddBlock />
        ) : (
          <CKCheckbox
            id={value}
            checked={isSelected}
            value={value}
            label={null}
          />
        )
      }
    >
      {isCreating ? (
        <p>
          <span>Create</span> <span className="font-medium">{label}</span>
        </p>
      ) : (
        <span className="flex items-center">
          {icon ? (
            <div className="inline-block w-4 h-4 mr-3 ml-1">{icon}</div>
          ) : null}
          <Highlighter
            autoEscape
            searchWords={[inputValue || '']}
            textToHighlight={textToHighlight}
            highlightClassName="ck-highlight"
          ></Highlighter>
        </span>
      )}
    </CKSelectListItem>
  );
};

const shouldSkipUpdate = (
  prevProps: CKMultiPickerItemProps,
  nextProps: CKMultiPickerItemProps
) => {
  if (prevProps.inputValue !== nextProps.inputValue) return false;
  if (prevProps.isDisabled !== nextProps.isDisabled) return false;
  if (prevProps.isHighlighted !== nextProps.isHighlighted) return false;
  if (prevProps.isSelected !== nextProps.isSelected) return false;
  if (prevProps.textToHighlight !== nextProps.textToHighlight) return false;

  return true;
};

export default React.memo(CKMultiPickerItem, shouldSkipUpdate);
